import { createSelector } from '@ngrx/store';
import { getCartDeliveryAddress } from '../getCartDeliveryAddress';

export const isCartDeliverableActionPresent = createSelector(getCartDeliveryAddress, (deliveryAddress) => deliveryAddress?.DeliverableAction != null);
